import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { LayoutProps, PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'
export const pageUrl = '/[locale]/fundraising-events/[slug]/thank-you?ids'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type ThankYouPageProps = PageProps<typeof pageUrl, { ids?: string[] }>
export type ThankYouLayoutProps = LayoutProps<typeof pageUrl>
